import * as React from "react";
import {
    DokumentAuswahl,
    type DokumentAuswahlErgebnis,
} from "../../documents/auswahl/DokumentAuswahl";
import "../v3/vorgangV3.css";

/**
 * Die Dokument-Auswahl in der Dialog-Hülle des Vorgangs.
 *
 * Die Fläche selbst bringt keine Hülle mit (sie steht auch im Mail-Fenster
 * und in den Kontaktdetails); hier bekommt sie den Schleier des V4-Designs.
 * Bewusst KEIN Fluent-Dialog (PO 09.09.2026): eigene Schicht, eigene Farben.
 *
 * `.kvp-rd` gehört an die Hülle, nicht an die Fläche — die Farbvariablen des
 * Refined-Designs hängen daran, und im Mail-Fenster gibt es sie nicht.
 */
type Props = {
    vorgangId: number;
    contactId: number | null;
    contactName?: string | null;
    /** To-do, an das die Auswahl gehängt wird; null = an den Vorgang selbst. */
    todoId: number | null;
    /** Dokumente, die im Strang schon liegen — Heimat wie Gast. */
    vorhandene: ReadonlySet<number>;
    onClose: () => void;
    onUebernehmen: (auswahl: DokumentAuswahlErgebnis) => void | Promise<void>;
};

export const DokumentAuswahlDialogV4: React.FC<Props> = ({
    contactId,
    contactName,
    todoId,
    vorhandene,
    onClose,
    onUebernehmen,
}) => (
    <div className="kvp-rd vg3-modal-hg" role="presentation" onClick={onClose}>
        <div
            className="vg3-modal dok-aw-huelle"
            role="dialog"
            aria-modal="true"
            aria-label={todoId != null ? "Dokument an dieses To-do" : "Dokument an diesen Vorgang"}
            // Ohne Überschrift und ohne Innenabstand: die Fläche bringt Reiter,
            // ✕ und Fuß selbst mit und geht wie ein Dateidialog bis an den Rand.
            // `.dok-aw-huelle`: über die Ecke unten rechts größer/kleiner ziehbar.
            style={{
                display: "flex",
                flexDirection: "column",
                width: "min(920px, calc(100vw - 32px))",
                height: "min(540px, calc(100vh - 32px))",
                maxHeight: "none",
                position: "relative",
                padding: 0,
                gap: 0,
                overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div style={{ flex: "1 1 auto", minHeight: 0, display: "flex" }}>
                <DokumentAuswahl
                    contactId={contactId}
                    kundeName={contactName ?? null}
                    ausschluss={vorhandene}
                    uebernehmenText="Hinzufügen"
                    onUebernehmen={(auswahl) => {
                        void onUebernehmen(auswahl);
                        onClose();
                    }}
                    onAbbrechen={onClose}
                />
            </div>
        </div>
    </div>
);

export default DokumentAuswahlDialogV4;
